import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/core';

import { FormSection, FormCTAButton } from '../../../../common/components/Form/Form';
import { DateInput } from '../../../../common/components/Form/FormDateInput';
import { Notice, NoticeThinText } from '../../../../common/components/Notice';
import { apiV1 } from '../../../../common/api/api';
import { DocumentArchiveButton } from '../../../../common/components/DocumentArchiveButton';
import { getFolderPath } from '../../../../common/routes';
import { history } from '../../../../common/helpers/history';
import Exclude from '../../../../roleBasedAccess/Exclude';
import { BlocHForm, isHbProjectTrackingReady } from './BlocHForm';

export const BlocHTab4 = ({ documentsVersion, ...props }) => {
  const folderId = props.blocH?.folderId;
  const [fundReleaseReady, setFundReleaseReady] = useState(null);
  useEffect(() => {
    if (!folderId) return undefined;
    let active = true;
    apiV1
      .get(`/folders/${folderId}/company_documents`)
      .then(({ data }) => {
        if (active) setFundReleaseReady(Boolean(data.fundReleaseReady));
      })
      .catch(() => {
        if (active) setFundReleaseReady(false);
      });
    return () => {
      active = false;
    };
  }, [folderId, documentsVersion]);

  return (
    <BlocHForm {...props}>
      {(formik, initialValues) => {
        const { hasHbCompanyTracking } = initialValues;
        const documentsPending =
          fundReleaseReady === false && !initialValues.paidInvoicesReceivedAt;

        return (
          <>
            <Exclude
              exclude="folder:bloc_h:tab_1:form_section_1:read"
              no={() => (
                <FormSection title="Déblocage de fonds">
                  {documentsPending && (
                    <Notice variant="info" mb="2rem">
                      <NoticeThinText>
                        La date de réception se débloque lorsque les pièces de chaque entreprise
                        sont validées dans « Réception docs entreprise » et que le document
                        d’évaluation de fin de projet est validé.
                      </NoticeThinText>
                    </Notice>
                  )}

                  <DateInput
                    label="Dernière date de réception des pièces de déblocage des fonds"
                    name="paidInvoicesReceivedAt"
                    id="paidInvoicesReceivedAt"
                    disabled={
                      (!hasHbCompanyTracking && !formik.values.projectEndFeedbackRequestSentAt) ||
                      documentsPending ||
                      fundReleaseReady === null
                    }
                  />

                  <Notice variant="info" mb="2rem">
                    <NoticeThinText>
                      Envoyer si nécessaire aux financeurs concernés le dossier pour déblocage des
                      fonds
                    </NoticeThinText>
                  </Notice>

                  <DocumentArchiveButton
                    mb="2rem"
                    folderId={folderId}
                    kind="project_end"
                    label="Télécharger les pièces de fin de projet"
                    isDisabled={!initialValues.paidInvoicesReceivedAt}
                    hint={
                      initialValues.paidInvoicesReceivedAt
                        ? null
                        : 'Disponible une fois la date de réception des pièces enregistrée.'
                    }
                  />

                  <DateInput
                    label="Demande de déblocage des fonds"
                    name="fundReleaseRequestedAt"
                    id="fundReleaseRequestedAt"
                    disabled={!formik.values.paidInvoicesReceivedAt}
                  />

                  <DateInput
                    label="Date de déblocage des fonds"
                    name="fundsReleasedAt"
                    id="fundsReleasedAt"
                    disabled={!formik.values.fundReleaseRequestedAt}
                  />
                </FormSection>
              )}
            />

            <Box textAlign="center">
              <FormCTAButton
                disabled={
                  (hasHbCompanyTracking && !isHbProjectTrackingReady(formik.values)) ||
                  (!hasHbCompanyTracking &&
                    (!formik.values.projectLaunchInfosReceivedAt ||
                      !formik.values.projectEndFeedbackRequestSentAt ||
                      !formik.values.projectEndReceivedAt)) ||
                  !formik.values.paidInvoicesReceivedAt ||
                  !formik.values.projectEndReviewPlannedAt ||
                  !formik.values.isRecipientContacted ||
                  !formik.values.projectEndReviewDate ||
                  !formik.values.bfpTransmissionType
                }
                onClick={() =>
                  formik
                    .submitForm()
                    .then(() => history.push(getFolderPath('bloc_i', initialValues.folderId)))
                }
              >
                Clôture pour aboutissement
              </FormCTAButton>
            </Box>
          </>
        );
      }}
    </BlocHForm>
  );
};
